import { BcEmployeeAuthFacade, BcEmployeeLoginCancelledAction, BcEmployeeLoginSuccessfulAction } from '@bayclubs/employee-auth';
import { effect, inject, Injectable, OnDestroy } from '@angular/core';
import { ReplaySubject, Subscription } from 'rxjs';

import { AuthService as HorizonAuthService } from '@bayclubs/horizon';
import { AuthenticationService } from '@bayclubs/utils';
import { Actions, ofActionDispatched } from '@ngxs/store';

import { environment } from '../../../environments/environment';

/**
 * Backs @bayclubs/utils SecurityService, which loads GroupClasses/SubBoard/Providers privileges
 * once `isAuthenticated()` is true or `authenticated` emits true.
 * Legacy: driven by the @bayclubs/employee-auth token exchange actions.
 * MSAL: there is no exchange (and no BcEmployeeLoginSuccessfulAction), so the MSAL account state
 * drives it - otherwise privileges never load, GcPermissionGuard never resolves and the app
 * renders a blank page after login.
 */
@Injectable()
export class AuthService extends AuthenticationService implements OnDestroy {

  private readonly isMsal = environment.isMsalAuthenticationEnabled;
  private readonly horizonAuth = this.isMsal ? inject(HorizonAuthService) : null;

  private subscriptions: Subscription[] = [];

  public authenticated = new ReplaySubject<boolean>(1);

  isAuthenticated(): boolean {
    return this.isMsal ? this.horizonAuth!.isAuthenticated() : this.auth.getHasTokenSnapshot();
  }

  constructor(
    private auth: BcEmployeeAuthFacade,
    private actions$: Actions
  ) {
    super();
    if (this.isMsal) {
      effect(() => {
        if (this.horizonAuth!.isAuthenticated()) {
          this.authenticated.next(true);
        }
      });
    } else {
      this.subscriptions.push(
        this.actions$.pipe(ofActionDispatched(BcEmployeeLoginSuccessfulAction)).subscribe(() => this.authenticated.next(true)),
        this.actions$.pipe(ofActionDispatched(BcEmployeeLoginCancelledAction)).subscribe(() => this.authenticated.next(false))
      );
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub?.unsubscribe())
  }

}
